import { createApi } from "@reduxjs/toolkit/query/react";
import { extendedBaseQuery } from "../basequery";

export const sathiProgramApi = createApi({
  reducerPath: "sathiProgramApi",
  baseQuery: extendedBaseQuery,
  tagTypes: ["SathiProgram"],
  endpoints: (builder) => ({
    getSathiProgramUsers: builder.query({
      query: (params) => {
        const query = {};
        if (params?.skip) query.skip = params.skip;
        if (params?.limit) query.limit = params.limit;
        if (params?.search) query.search = params.search;
        if (params?.filter) query.filter = params.filter;
        if (params?.sortBy) query.sortBy = params.sortBy;
        if (params?.orderBy) query.orderBy = params.orderBy;
        if (params?.startDate) query.startDate = params.startDate;
        if (params?.endDate) query.endDate = params.endDate;
        if (params?.userType) query.userType = params.userType;
        if (params?.organizationId)
          query.organizationId = params.organizationId;
        if (params?.distributorId) query.distributorId = params.distributorId;
        if (params?.eventPlace) query.eventPlace = params.eventPlace;
        if (params?.tag) query.tag = params.tag;
        return {
          url: `sathi-program/users/all${
            Object.keys(query).length > 0 ? "?" : ""
          }${new URLSearchParams(query)}`,
          method: "GET",
        };
      },
      providesTags: ["SathiProgram"],
    }),
  }),
});

export const {
  useGetSathiProgramUsersQuery,
  useLazyGetSathiProgramUsersQuery,
} = sathiProgramApi;
